import { useRootStoreContext } from '../../stores/RootStore';
import AvailableTimes from './components/AllSuggestions';
import WaitingListTimes from './components/WaitingListTimes';
import BookingSelection from './components/BookingSelection';

const ModalConductor = () => {
    const {
        UIStore: {
            reducer: [{ modalConfig }],
        },
    } = useRootStoreContext();

    switch (modalConfig.type) {
        case 'None':
            return null;
        case 'AvailableTimes':
            return (
                <AvailableTimes
                    restaurantId={modalConfig.restaurantId}
                    restaurantSlug={modalConfig.restaurantSlug}
                />
            );
        case 'WaitingListTimes':
            return (
                <WaitingListTimes
                    restaurantId={modalConfig.restaurantId}
                    restaurantSlug={modalConfig.restaurantSlug}
                    isWaitingListWhenFullyBooked={
                        modalConfig.isWaitingListWhenFullyBooked
                    }
                />
            );
        case 'BookingSelection':
            return <BookingSelection {...modalConfig} />;
        default:
            return null;
    }
};

export default ModalConductor;
